import { ACTIVATION_CACHE_TIME, ACTIVATION_STALE_TIME, getCalendar2024Stats, setCalendar2024Resolve } from '@api/activation';
import { useMutation, useQuery } from '@tanstack/react-query';
import React, { useState } from 'react'
import PagesHeader from '@components/PagesHeader';
import "./style.scss"
import NiceModal from '@ebay/nice-modal-react';
import SectionHeader from '@components/SectionHeader';
import { DETAILS_CACHE_TIME, DETAILS_REFETCH_INVERVAL, DETAILS_STALE_TIME, getUserDetails } from '@api/consumer';

export default function Calendar2024() {
  const [loading, setIsLoading] = useState(false)

  const { data: calnedarStats, isLoading, refetch } = useQuery({
    queryKey: ["calendar-2024-stats"],
    queryFn: getCalendar2024Stats,
    staleTime: ACTIVATION_STALE_TIME,
    cacheTime: ACTIVATION_CACHE_TIME,
  });

  const { refetch: refetchDetails } = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
    enabled: !!localStorage.getItem("token"),
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const daysState = Object.values(calnedarStats?.passport?.day ?? {});

  function handleButtonClick(ident) {
    setCalendar2024Resolve(
      ident,
      resObj => {
        refetch()
        NiceModal.show("redeem-calendar-2024", { points: resObj.data.payout })
        refetchDetails()
      },
      setIsLoading
    )
  }

  return (
    <section className={`game-page calendar2024-mechanics`}>
      <PagesHeader back>
        <strong>Inspiration Club</strong> Kalender
      </PagesHeader>
      <SectionHeader>
        <strong>Klicke auf das Fenster</strong> und sammle deine Belohnung.
      </SectionHeader>

      <div className="game-wrapper">
        {daysState.map((day, index) => {
          const isClaimed = day.claimed
          const isAvailable = day.available
          const points = day.points

          const shouldButtonBeDisabled = (isClaimed || !isAvailable) || (isClaimed === null && isAvailable === null) || loading

          let copyToShow

          switch (true) {
            case isClaimed:
              copyToShow = <div className='points'><span><strong>+{points}</strong><br />punkte</span></div>
              break
            case isClaimed === null && isAvailable === null:
              copyToShow = <span><strong>{index + 1}</strong></span>
              break
            default:
              copyToShow = <span><strong>{index + 1}</strong></span>
              break
          }

          return (
            <button
              key={index}
              onClick={() => handleButtonClick(day.activation)}
              className={`calendar-tile ${isAvailable ? "available" : isClaimed ? "claimed" : isClaimed === false && isAvailable === false ? "missed" : ""}`}
              disabled={shouldButtonBeDisabled}
            >
              <div className="inner">{copyToShow}</div>
            </button>
          )
        })}
      </div>
    </section>
  )
}
